<mat-chip-set>
    @if (internalValue()?.length === 0) {
        <mat-chip
            tabIndex="0"
            st-topic-card-type-color
            [itemType]="noTypeItem">
            {{ getItemLabel(noTypeItem) }}
        </mat-chip>
    }
    @for (item of itemsToShow(); track item) {
        <mat-chip
            removable
            st-topic-card-type-color
            [itemType]="item"
            [data]="record()"
            [matTooltip]="getItemLabel(item)"
            (removed)="removeItem(item)">
            {{ getItemLabel(item) }}
            <button
                *ngIf="showRemove() && !disabled()"
                matChipRemove
                tabIndex="0"
                class="st-topic-type-button-remove"
                [attr.aria-label]="'remove ' + item">
                <mat-icon>close</mat-icon>
            </button>
        </mat-chip>
    }
    @if (showMaxValuesToShowLabel()) {
        <mat-chip
            #triggerOverlay="cdkOverlayOrigin"
            class="st-topic-type-plus-chip"
            cdkOverlayOrigin
            [disabled]="disabled()"
            (mouseenter)="showStaffTooltip()"
            (mouseleave)="onMouseOut($event)">
            {{ maxValuesToShowLabel() }}
        </mat-chip>
        <ng-template
            cdkConnectedOverlay
            [cdkConnectedOverlayOrigin]="triggerOverlay"
            [cdkConnectedOverlayOpen]="isListOpen()"
            (attach)="panelAttached()">
            <mat-list class="st-topic-type-list__tooltip__content">
                @for (item of tooltipItems(); track item) {
                    <mat-list-item>
                        <div class="st-topic-type-list__tooltip__info">
                            {{ item.title }}
                        </div>
                    </mat-list-item>
                }
            </mat-list>
        </ng-template>
    }
    <mat-chip
        *ngIf="showAdd() && !disabled()"
        class="st-topic-type-add"
        tabIndex="0"
        selectable="false"
        [class.st-topic-type-add-invalid]="required() && internalValue()?.length === 0"
        [class.st-topic-type-add-required]="required()"
        [matMenuTriggerFor]="listDropDownMenu"
        [matTooltip]="label()"
        (menuClosed)="valueChanged()"
        (keyup.space)="openMatMenu()">
        <mat-icon matChipAvatar>add</mat-icon>
        {{ label() }}
    </mat-chip>
</mat-chip-set>

<mat-menu #listDropDownMenu="matMenu">
    <mat-selection-list
        st-click-stop-propagation
        [ngModel]="internalValue()"
        (selectionChange)="internalValueChanged($event)">
        <mat-list-option
            *ngFor="let item of itemList()"
            [dir]="dir"
            [value]="item.id"
            (keydown.Tab)="onTabOrEscPress()"
            (keydown.Escape)="onTabOrEscPress()">
            {{ item.title }}
        </mat-list-option>
    </mat-selection-list>
</mat-menu>
